import { useStores } from "../../../../..";
import {
  DeleteDefaultButton,
  PlusDefaultButton,
  SaveDefaultButton,
  UpdateDefaultButton,
} from "../../../../../Components/IconButtons";
import { LearningPathStore } from "../../../../../Stores/LearningPathStores/LearningPathStore";
import getModuleNode from "./ModuleNode";
import TreeNodeApi from "./TreeNodeApi";
import { TreeNode } from "./TreeNode";
import { observer } from "mobx-react";
import { StyledInputWithBorder } from "../../../../../Components/StyledComponents/Input";
import getResourceNode from "./ResourceNode";

const getLearningPathNode = (
  learningPathStore: LearningPathStore
): TreeNodeApi => {
  return {
    value: learningPathStore.learningPath.learningPathId,
    label: <LearningPathNode learningPathStore={learningPathStore} />,
    children: [
      {
        value: "modules_" + learningPathStore.learningPath.learningPathId,
        label: (
          <ModulesOrResourcesGenerilizeNode
            learningPathStore={learningPathStore}
            label={"Модули"}
            moduleOrResource={true} // TODO change
          />
        ),
        children: [
          ...Array.from(
            learningPathStore.learningPath.learningPathModules,
            (lpModule) => getModuleNode(learningPathStore, lpModule)
          ),
        ],
      },
      {
        value: "resources_" + learningPathStore.learningPath.learningPathId,
        label: (
          <ModulesOrResourcesGenerilizeNode
            learningPathStore={learningPathStore}
            label={"Ресурсы"}
            moduleOrResource={false}
          />
        ),
        children: [
          ...Array.from(
            learningPathStore.learningPath.learningPathResources,
            (lpResource) => getResourceNode(learningPathStore, lpResource)
          ),
        ],
      },
    ],
  };
};

const ModulesOrResourcesGenerilizeNode: React.FC<{
  learningPathStore: LearningPathStore;
  label: string;
  moduleOrResource: boolean;
}> = observer(({ learningPathStore, label, moduleOrResource }) => {
  let learningPathWindowStore = useStores().learningPathWindowStore;

  return (
    <TreeNode
      label={label}
      buttons={
        <>
          {learningPathStore.doSave && (
            <PlusDefaultButton
              withShadow={false}
              onClick={() => {
                learningPathWindowStore.onChangeChosenLearningPath(
                  learningPathStore
                );
                if (moduleOrResource)
                  learningPathWindowStore.onAddedLearningPathModuleCalloutShow();
                else
                  learningPathWindowStore.onAddedLearningPathResourceCalloutShow();
              }}
            />
          )}
        </>
      }
    />
  );
});

const LearningPathNode: React.FC<{ learningPathStore: LearningPathStore }> =
  observer(({ learningPathStore }) => {
    let learningPathWindowStore = useStores().learningPathWindowStore;
    return (
      <TreeNode
        label={
          learningPathStore.doSave ? (
            <StyledInputWithBorder
              value={learningPathStore.tempName}
              onChange={learningPathStore.onChangeTempName}
            />
          ) : (
            learningPathStore.learningPath.learningPathName
          )
        }
        buttons={
          <>
            {learningPathStore.doSave && (
              <SaveDefaultButton
                withShadow={false}
                onClick={() => {
                  learningPathStore.onChangeName(learningPathStore.tempName);
                  learningPathStore
                    .saveLearningPathAsync()
                    .then(() => {
                      learningPathStore.onChangeDoSave(false);
                    })
                    .catch(() => {
                      alert("Произошла ошибка при сохранении");
                    });
                }}
              />
            )}
            {!learningPathStore.doSave && (
              <UpdateDefaultButton
                withShadow={false}
                onClick={() => {
                  learningPathStore.onChangeDoSave(true);
                }}
              />
            )}

            <DeleteDefaultButton
              withShadow={false}
              onClick={() => {
                learningPathWindowStore.onDeleteModalToDeleteLearningPathOpen(
                  learningPathStore.learningPath
                );
              }}
            />
          </>
        }
      />
    );
  });

export default getLearningPathNode;
